import logger from "./logger";

type DeviceChangeCallback = () => void | Promise<void>;

const callbacks = new Set<DeviceChangeCallback>();
let previousHandler: ((this: MediaDevices, event: Event) => any) | null = null;
let installed = false;

const installDeviceChangeHandler = () => {
  if (installed || !navigator.mediaDevices) return;

  previousHandler = navigator.mediaDevices.ondevicechange;
  navigator.mediaDevices.ondevicechange = async (event) => {
    previousHandler?.call(navigator.mediaDevices, event);

    await Promise.all(
      Array.from(callbacks).map(async (callback) => {
        try {
          await callback();
        } catch (error) {
          logger.error("Media device change handler failed:", error);
        }
      }),
    );
  };
  installed = true;
};

const uninstallDeviceChangeHandler = () => {
  if (!installed || callbacks.size > 0 || !navigator.mediaDevices) return;

  navigator.mediaDevices.ondevicechange = previousHandler;
  previousHandler = null;
  installed = false;
};

export const subscribeToMediaDeviceChange = (
  callback: DeviceChangeCallback,
) => {
  callbacks.add(callback);
  installDeviceChangeHandler();

  return () => {
    callbacks.delete(callback);
    uninstallDeviceChangeHandler();
  };
};
